module.exports = __webpack_public_path__ + "static/media/Trees.b0ae4605.png";